/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Board_SwitchInputs */

const cs_pipelines_board_switch = /** @type {(inputs: Pipelines_Board_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nástěnka`)
};

const en_pipelines_board_switch = /** @type {(inputs: Pipelines_Board_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Board`)
};

/**
* | output |
* | --- |
* | "Board" |
*
* @param {Pipelines_Board_SwitchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_board_switch = /** @type {((inputs?: Pipelines_Board_SwitchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Board_SwitchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_board_switch(inputs)
	return cs_pipelines_board_switch(inputs)
});